import React from 'react';
import { Message } from 'semantic-ui-react';
import { renderInlineReferences } from '../parseInlineReferences';

const referencesToText = (referenceIds) => referenceIds.map((id) => `[[ref:${id}]]`).join(' ');

const Quote = ({ block, onReferenceClick }) => {
  const primaryReferenceId = block.referenceIds[0];

  return (
    <Message
      className="report-quote-block"
      role="button"
      tabIndex={0}
      style={{
        cursor: 'pointer',
        margin: '1.5em 0',
        padding: '1.25em 1.5em',
        borderRadius: '10px',
        borderLeft: '4px solid #2a78d6',
        boxShadow: 'none',
      }}
      onClick={() => onReferenceClick(primaryReferenceId)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') onReferenceClick(primaryReferenceId);
      }}
    >
      <blockquote style={{
        margin: 0, fontStyle: 'italic', fontSize: '1.05em', lineHeight: 1.5,
      }}
      >
        {`“${block.text}”`}
      </blockquote>
      <div style={{ marginTop: '10px' }}>
        {renderInlineReferences(referencesToText(block.referenceIds), onReferenceClick)}
      </div>
    </Message>
  );
};

export default Quote;
